import BasicDetails from "../../components/Register/BasicDetails";
import BusinessProof from "../../components/Register/BusinessProof";
import ProfileCreation from "../../components/Register/ProfileCreation";
import RegistrationSideBar from "../../components/Register/RegistrationSideBar";
import ShopLocation from "../../components/Register/ShopLocation";
import Arrow from "../../assets/Register/arrowleft.svg";
import { Image } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { routes } from "../../Routes";
import Notification from "../../modals/Notification";
import { userSignup } from "../../components/Actions/userActions";
import CompleteProfile from "../../modals/CompleteProfile";
import { useNavigate } from "react-router";
import AlreadyRegisteredModal from "../../modals/AlreadyRegisteredmodal";
import { useTranslation } from "react-i18next";
import "../../styles.css";
import { LoginData, loginUser, loginUserSuccess } from "../../Redux/Action/loginAction";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import LoadingSpinner from "../../components/Loading";
import { toast } from "react-toastify";

const UserRegistration = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [data, setretailerInfo] = useState("");
  const [mobile, setuserPhone] = useState("");
  const [existemail, setexistemail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentpage, setcurrentpage] = useState(0);
  const { user } = useSelector((state) => state?.login);
  const [component, setComponent] = useState(() => 0);
  const [shopLocationData, setshopLocationData] = useState("");

  console.log("user==>", user);

  useEffect(() => {
    const retailerInfo = localStorage.getItem("retailer_info");
    const userPhone = localStorage.getItem("UserPhone");

    setretailerInfo(retailerInfo ? JSON.parse(retailerInfo) : "");
    setuserPhone(userPhone || "");

    if (user) {
      // If user is already available, jump to BusinessProof step (step 2)
      setComponent(2);
      localStorage.setItem("registrationComponent", 2);
    } else {
      const savedStep = Number(localStorage?.getItem("registrationComponent"));
      setComponent(savedStep || 0);
    }
  }, [user]);

  // const data =
  //   localStorage?.getItem("retailer_info") != "undefined"
  //     ? JSON.parse(localStorage?.getItem("retailer_info"))
  //     : "";
  // const mobile = localStorage?.getItem("UserPhone");

  const dispatch = useDispatch();

  //Use States
  const [BasicDetailData, setsBasicDetailData] = useState("");
  const [BusinessProofData, setBusinessProofData] = useState("");
  const [showNotification, setshowNotification] = useState(false);
  const [showNotificationMessage, setshowNotificationMessage] = useState("");
  const [showCompleteModal, setShowCompleteModal] = useState(false); // State for modal visibility
  const [message, setmessage] = useState(0);

  useEffect(() => {
    localStorage.setItem("registrationComponent", component);
  }, [component]);

  const handleDataSubmit = (dataType, Data) => {
    console.log(dataType, Data);
    if (dataType === "shopLocationData") {
      localStorage?.setItem("shopdata", JSON.stringify(Data));
      setshopLocationData(Data);
      setComponent(component + 1);
      //   }
      // });
    } else if (dataType === "basicDetailsData") {
      setLoading(true);
      const response = dispatch(userSignup(Data));
      response
        .then((result) => {
          console.log("result===>", result);

          if (result?.payload?.result?.status_code === 200) {
            localStorage?.setItem("shopdata", JSON.stringify(Data));
            setshopLocationData(Data);
            setComponent(component + 1);
            console.log("RESPONSE OF BASICDETAILS", result);
            const loginData = {
              login: result?.payload.result?.login.toLowerCase(),
              password: result?.payload.result?.password,
            };

            // Call the login action after successful registration
            let payload = {
              user_name: Data?.email,
            };
            dispatch(LoginData(payload))
              // dispatch(loginUser(loginData.login, loginData.password))
              .then((data) => {
                if (data?.result?.status_code === 200) {
                  // Handle successful login
                  setmessage(1);
                  dispatch(loginUserSuccess(data));
                  // setShowCompleteModal(true);
                  setsBasicDetailData(Data);
                  setComponent(component + 1);
                } else {
                  setshowNotificationMessage(t(data?.result?.status));
                }
              })
              .catch((loginError) => {
                console.error("Error during login:", loginError);
              });
          } else if (
            result?.payload?.result?.status ==
            "With Email Retailer Already Registered"
          ) {
            //setshowNotification(true);
            // setshowNotificationMessage(t("email_already_registered"));
            // setexistemail(true);
            toast.error(t("Retailer is already registered with this Email"));
            // router.push(routes.login);
          } else if (result?.payload?.result?.status_code === 400) {
            toast.error(t(result?.payload?.result?.status));
          }

          console.log("usercreation", JSON.stringify(Data));
          localStorage?.setItem("basicdata", JSON.stringify(Data));
          console.log(result);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
          // Your final logic goes here
          console.log("Signup process finished");
          // You can hide a loader here, for example
        });
      // router.push(routes.Orders)
    } else if (dataType === "businessProofData") {
      if (
        Data?.bussiness_proof?.[0]?.name === "" &&
        Data?.bussiness_proof?.[1]?.name === "" &&
        Data?.bussiness_proof?.[2]?.name === ""
      ) {
        setComponent(component + 1);
      } else {
        setLoading(true);
        const response = axiosInstance
          .post(URLS.UPDATE_RETAILER_DETAILS, Data)
          .then((result) => {
            // console.log("REDDEEEEEE==>", result);

            if (result?.data?.result?.status === "Update Successfully") {
              console.log("businessproof data", Data);
              setBusinessProofData(Data.bussiness_proof);
              setShowCompleteModal(true);
              setComponent(component + 1);
              setLoading(false);

            }
            localStorage.setItem("businessproofdata", JSON.stringify(Data));
            console.log(result);
          })
          .catch((error) => {
            console.error("There was an error making the request:", error);
          });
      }
    } else if (dataType === "profile_creation_data") {
      console.log("PPPEP", Data);

      const validUrls = Data?.image_urls.filter(
        (url) => url && url !== "undefined" && url.trim() !== ""
      );

      if (!validUrls || validUrls.length === 0) {
        setmessage(0);
        setShowCompleteModal(true);
      } else {
        const payload = {
          company_id: Data.company_id,
          image_urls: validUrls,
        };

        axiosInstance
          .post(URLS.UPLOAD_IMAGE_URLS, payload)

          .then((result) => {
            console.log("result", result?.data?.result[0]?.status);
            if (
              result?.data?.result[0]?.status ===
              "Images Urls Uploaded Successfully"
            ) {
              console.log("result", result);
              setShowCompleteModal(true);
              setmessage(0);

              // Optionally, you can handle post-upload actions here
              // let payloadLogin = {
              //   mobile: Data.mobile,
              //   password: Data.password
              // }
              // backgroundlogin(payloadLogin)
              // router.push(routes.login)
            }
          })
          .catch((error) => {
            console.error("Error uploading images:", error);
            // Handle error appropriately, e.g., show a message to the user
          });
      }
    }
  };

  const CurrentStep = [
    <ShopLocation
      onDataSubmit={handleDataSubmit}
      data={data}
      mobile={mobile}
      savedata={shopLocationData}
      showNotificationMessage={showNotificationMessage}
    />,
    <BasicDetails
      onDataSubmit={handleDataSubmit}
      data={data}
      mobile={mobile}
      shopLocationData={shopLocationData}
      savedata={BasicDetailData}
      showNotificationMessage={showNotificationMessage}
      email={existemail}
    />,
    <BusinessProof
      onDataSubmit={handleDataSubmit}
      data={data}
      savedata={BusinessProofData}
    />,
    <ProfileCreation onDataSubmit={handleDataSubmit} data={data} />,
  ];

  //Function calls when back button is clicked
  const handleBackClick = () => {
    setComponent(component - 1);
  };
  //Function calls when skip button is clicked
  const handleskip = () => {
    console.log("skip called");
    navigate(routes.onboarding);
  };

  return (
    <div className="flex bg-white min-h-screen scrollbar-none relative">
      {loading && <LoadingSpinner />}

      {/* Sidebar */}
      <div className="w-full md:w-1/4 fixed h-full z-10 bg-secondaryBlue">
        <RegistrationSideBar currentStep={component} />
      </div>

      {/* Content Area */}
      <div className="w-full md:ms-[25%] min-h-screen overflow-y-auto p-6">
        <div className="max-w-5xl mx-auto">
          {/* Top Navigation Row */}
          <div className="flex flex-row justify-between mb-6">
            {component == 1 ? (
              <p
                className="font-bold text-sm text-[#5C5C5C] flex items-center gap-3 cursor-pointer"
                onClick={handleBackClick}
              >
                <img className="w-6" src={Arrow} alt="arrow" />
                {t("back_to_previous")}
              </p>
            ) : (
              <div></div>
            )}
            {component > 2 && (
              <p
                className="font-bold text-sm text-[#5C5C5C] flex items-center gap-3 cursor-pointer"
                onClick={handleskip}
              >
                {t("skip")}
              </p>
            )}
          </div>

          {/* Modal Messages */}
          {showNotification && (
            <AlreadyRegisteredModal message={showNotificationMessage} />
          )}
          {showCompleteModal && (
            <CompleteProfile
              onClose={() => setShowCompleteModal(false)}
              message={message}
            />
          )}

          {/* Step Content */}
          {CurrentStep[component]}
        </div>
      </div>
    </div>
  );
};

export default UserRegistration;
